// utils/SignalRPayload.ts
export function tryParseJson(text: string): unknown | undefined {
    try { return JSON.parse(text); } catch { return undefined; }
}

// base64 / base64url → bytes
export function base64ToBytes(b64: string): Uint8Array {
    // normalize base64url to base64
    let s = b64.replace(/-/g, '+').replace(/_/g, '/');
    // pad to 4
    const pad = s.length % 4 ? 4 - (s.length % 4) : 0;
    if (pad) s += '='.repeat(pad);

    // atob may throw if not valid base64
    const bin = atob(s);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
}

/**
 * Accepts: object | string (json or base64) | Uint8Array
 * Returns: parsed JS object
 */
export function decodeSignalRArgument(raw: unknown): any {
    // Already a JS object? (SignalR can give you objects if server sends text/POCO)
    if (raw && typeof raw === 'object' && !(raw instanceof Uint8Array)) {
        return raw; // trust upstream JSON protocol
    }

    // Real binary
    if (raw instanceof Uint8Array) {
        const json = new TextDecoder().decode(raw);
        const parsed = tryParseJson(json);
        if (parsed !== undefined) return parsed;
        throw new Error('Binary payload was not valid JSON after UTF‑8 decode.');
    }

    // String: try JSON first, then base64 → UTF-8 → JSON
    if (typeof raw === 'string') {
        const direct = tryParseJson(raw);
        if (direct !== undefined) return direct;

        // Not JSON text → assume base64 of UTF‑8 JSON
        const bytes = base64ToBytes(raw);
        return bytes;
        const json = new TextDecoder().decode(bytes);
        const parsed = tryParseJson(json);
        if (parsed !== undefined) return parsed;

        throw new Error('String payload was neither JSON nor base64‑encoded JSON.');
    }

    throw new Error(`Unsupported payload type: ${typeof raw}`);
}
